var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import di from "../../di/serviceLocator";
import Loader from "../../../../../../shared-library/components/Loader";
import { NonStreamReportValue, } from "../../../../../../shared-library/components/commonTableVal";
var HistoricalLoansColumn = [
    {
        columnName: "Loan Code",
        key: "loancode",
    },
    {
        columnName: "Product",
        key: "loantype",
    },
    {
        columnName: "Sec/unsecured",
        key: "secureD_UNSECURED",
    },
    {
        columnName: "Start Date",
        key: "startdate",
    },
    {
        columnName: "End Date",
        key: "enddate",
    },
    {
        columnName: "ROI (closure)",
        key: "roi",
        tdCustomFunction: function (key) {
            return React.createElement("span", { className: "RobotoM_14_500" },
                key,
                "%");
        },
    },
    {
        columnName: " PF Received",
        key: "pfreceived",
        tdCustomFunction: function (key) {
            return (React.createElement("span", { className: "RobotoM_14_500" }, isNaN(parseInt(key)) ? key : NonStreamReportValue(key)));
        },
    },
    {
        columnName: "Interest received",
        key: "interesT_RECEIVED",
        tdCustomFunction: function (key) {
            return (React.createElement("span", { className: "RobotoM_14_500" }, isNaN(parseInt(key)) ? key : NonStreamReportValue(key)));
        },
    },
    {
        columnName: "Sanction Amt",
        key: "sanctionamt",
        tdCustomFunction: function (key) {
            return (React.createElement("span", { className: "RobotoM_14_500" }, isNaN(parseInt(key)) ? key : NonStreamReportValue(key)));
        },
    },
    {
        columnName: "Disbursement amt",
        key: "disbursementamt",
        tdCustomFunction: function (key) {
            return (React.createElement("span", { className: "RobotoM_14_500" }, isNaN(parseInt(key)) ? key : NonStreamReportValue(key)));
        },
    },
    {
        columnName: "Details of Exercised ESOPs",
        key: "detailsexercisedesops",
        tdCustomFunction: function (key) {
            return (React.createElement("span", { className: "RobotoM_14_500" }, isNaN(parseInt(key)) ? key : NonStreamReportValue(key)));
        },
    },
];
var HistoricalLoans = function () {
    var _a = __read(React.useState(), 2), loanDataState = _a[0], setloanDataState = _a[1];
    var historicalLoansData = useSelector(function (state) { return state.Clients.HistoricalView.reducersData.data; });
    var historicalLoader = useSelector(function (state) { return state.Clients.HistoricalView.commonData; }).loader;
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getHistoricalData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.clients.getHistoricalViewData({
                        acCode: selectedAccount.accountCode,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (selectedAccount && selectedAccount.accountCode)
            getHistoricalData();
    }, [selectedAccount.accountCode]);
    React.useEffect(function () {
        if (historicalLoansData)
            setloanDataState(historicalLoansData);
    }, [historicalLoansData]);
    return (React.createElement("section", { className: "section-padding" },
        React.createElement(Row, { className: "relationship-head-block mx-0 px-0" },
            React.createElement("div", { className: "DMSanBold_18_700 txt_blackOne1 ps-0" }, "Historical Loans - [As on 10th March 2020]")),
        historicalLoader ? (React.createElement("div", { className: "position-relative client-loader" },
            React.createElement(Loader, null))) : (React.createElement(GenericTable, { columns: HistoricalLoansColumn, data: loanDataState, parentClassName: "salestableParentClass table-responsive commonscroll-new", tableClassName: "salestableclass", message: {
                msg: "No Data Found",
                show: loanDataState && loanDataState.length === 0,
                icon: "",
            } }))));
};
export default HistoricalLoans;
